import { useMutation, useQueryClient } from "react-query";
import { RestError } from "../../services/rest-service/RestService";
import { BaseUseMutationParameters } from "../BaseUseMutationParameters";
import { keys } from "./Keys";
import { IUIDefaultViewModel } from "../../services/ui-personalization-data-service/Models";
import UIPersonalizationDataService from "../../services/ui-personalization-data-service/UIPersonalizationDataService";

type MutationContextType = {
    previousInstances: IUIDefaultViewModel[] | undefined;
};

export type UseSaveUserDefaultViewParams = {

} & BaseUseMutationParameters<IUIDefaultViewModel, IUIDefaultViewModel>;


export function useSaveUserDefaultView({
    onSuccess,
    onError
}: UseSaveUserDefaultViewParams) {
    const queryClient = useQueryClient();

    return useMutation<IUIDefaultViewModel, RestError, IUIDefaultViewModel, MutationContextType>(
        (model) => {
            return UIPersonalizationDataService.saveUserDefaultView(model);
        },
        {
            onMutate: async (item: IUIDefaultViewModel) => {

                await queryClient.cancelQueries(keys.all);

                const previousInstances = queryClient.getQueryData<IUIDefaultViewModel[]>(
                    keys.list()
                );


                queryClient.setQueryData<IUIDefaultViewModel[]>(
                    keys.list(),
                    (old?: IUIDefaultViewModel[]) => {

                        const existing = old?.find(o => o.id === item.id);

                        return existing
                            ? old?.map(o => (o.id === item.id ? item : o)) ?? []
                            : [...(old ?? []), item];
                    }
                );


                return {
                    previousInstances: previousInstances ? [...previousInstances, item] : [item]
                };
            },
            onError: onError,
            onSuccess: onSuccess,
            onSettled: (_data, error, item, context) => {


                if (error && context?.previousInstances) {
                    queryClient.setQueryData<IUIDefaultViewModel[]>(
                        keys.list(),
                        context?.previousInstances
                    );
                }

                queryClient.invalidateQueries(keys.list());
            }
        }
    );
}
